/* ==========================================================
   ART STORY · Shopify theme JavaScript
   ========================================================== */

// ---- Navigation scroll state ----
var nav = document.getElementById('nav');
if (nav && !nav.classList.contains('solid')) {
  var updateNav = function () {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  };
  window.addEventListener('scroll', updateNav);
  updateNav();
}

// ---- Mobile menu ----
var mobileToggle = document.getElementById('mobileToggle');
var navLinks = document.getElementById('navLinks');
if (mobileToggle && navLinks) {
  mobileToggle.addEventListener('click', function () {
    navLinks.classList.toggle('open');
  });
  navLinks.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { navLinks.classList.remove('open'); });
  });
}

// ---- Hero slideshow ----
var slides = document.querySelectorAll('.hero-slide');
if (slides.length > 1) {
  var idx = 0;
  setInterval(function () {
    slides[idx].classList.remove('active');
    idx = (idx + 1) % slides.length;
    slides[idx].classList.add('active');
  }, 5000);
}

// ---- Reveal on scroll ----
if ('IntersectionObserver' in window) {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
} else {
  document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
}

// ---- Gallery modal ----
var modal = document.getElementById('modal');
var modalImg = document.getElementById('modalImg');
var modalClose = document.getElementById('modalClose');
if (modal && modalImg) {
  document.querySelectorAll('.gallery-item[data-img]').forEach(function (item) {
    item.addEventListener('click', function (e) {
      if (item.tagName === 'A') return; // links navigate, don't open modal
      modalImg.src = item.dataset.img;
      modal.classList.add('open');
    });
  });
  if (modalClose) modalClose.addEventListener('click', function () { modal.classList.remove('open'); });
  modal.addEventListener('click', function (e) {
    if (e.target === modal) modal.classList.remove('open');
  });
}

// ---- FAQ accordion ----
document.querySelectorAll('.faq-q').forEach(function (q) {
  q.addEventListener('click', function () {
    var item = q.closest('.faq-item');
    var wasOpen = item.classList.contains('open');
    item.parentElement.querySelectorAll('.faq-item.open').forEach(function (o) {
      o.classList.remove('open');
    });
    if (!wasOpen) item.classList.add('open');
  });
});
